import { BookingType } from '../domain/LoadOffer'

export function getSummaryRateLabel(bookingType: BookingType): string {
  switch (bookingType) {
    case BookingType.BidAward:
      return 'New rate'
    case BookingType.BidCounter:
      return 'Counter offer'
    case BookingType.BidTooHigh:
      return 'Book now for'
    default:
      return 'Rate'
  }
}
